import { z } from 'zod';
import { ReferenceSchema } from '../domain/models';

export const GooglePlacesPredictionSchema = z.object({
  description: z.string(),
  place_id: z.string(),
  reference: ReferenceSchema,
});

export const GooglePlacesPlacePredictionSchema = z.object({
  predictions: z.array(GooglePlacesPredictionSchema),
});

export const GooglePlacesCoordinateSchema = z.object({
  lat: z.number(),
  lng: z.number(),
});

export const GooglePlacesGeometrySchema = z.object({
  location: GooglePlacesCoordinateSchema,
});

export const GooglePlacesAddressComponentsSchema = z.object({
  long_name: z.string(),
  short_name: z.string(),
  types: z.array(z.string()),
});

export const GooglePlacesPlaceSchema = z.object({
  formatted_address: z.string(),
  geometry: GooglePlacesGeometrySchema,
  place_id: z.string(),
  name: z.string(),
  address_components: z.array(GooglePlacesAddressComponentsSchema),
});

export const GooglePlacesPlaceResultSchema = z.object({
  result: GooglePlacesPlaceSchema,
});

export const GooglePlacesSearchAddressQueryParamsSchema = z.object({
  search: z.string().optional(),
});

export type GooglePlacesPrediction = z.infer<
  typeof GooglePlacesPredictionSchema
>;

export type GooglePlacesPlacePrediction = z.infer<
  typeof GooglePlacesPlacePredictionSchema
>;

export type GooglePlacesCoordinate = z.infer<
  typeof GooglePlacesCoordinateSchema
>;

export type GooglePlacesGeometry = z.infer<typeof GooglePlacesGeometrySchema>;

export type GooglePlacesAddressComponents = z.infer<
  typeof GooglePlacesAddressComponentsSchema
>;

export type GooglePlacesPlace = z.infer<typeof GooglePlacesPlaceSchema>;

export type GooglePlacesPlaceResult = z.infer<
  typeof GooglePlacesPlaceResultSchema
>;

export type GooglePlacesSearchAddressQueryParams = z.infer<
  typeof GooglePlacesSearchAddressQueryParamsSchema
>;

export type GooglePlacesSearchAddressResponse = GooglePlacesPlacePrediction;

export type GooglePlacesAddressDetailsResponse = GooglePlacesPlaceResult;
